import { getEdgeFunctionHeaders } from '../supabase';
export interface RobotExcelExample {
  base64Data: string;
  selectedSheet: string;
  filename: string;
  aiOutput: {
    generalData: Record<string, any>;
    details: Record<string, any>[];
  };
}

export interface GenerateRobotRequest {
  receiverName: string;
  examples: RobotExcelExample[];
  extraInstructions?: string;
}

export interface GenerateRobotResponse {
  success: boolean;
  code?: string;
  fixExplanation?: string;
  error?: string;
}

export const generateRobot = async (
  request: GenerateRobotRequest
): Promise<GenerateRobotResponse> => {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_SUPABASE_URL}/functions/v1/generate-robot`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(await getEdgeFunctionHeaders()),
        },
        body: JSON.stringify(request),
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to generate robot');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error generating robot:', error);
    throw error;
  }
};
